import { ErrorLabel, FormLabel } from "@ui/internal/components/label";
import React from "react";

interface PrefixInput {
  prefix?: "https://" | "lat" | "long";
  error: string | undefined;
  onChange: (value: string) => void; // This will receive the full value with prefix
  value?: string; // This should be the full value (https://example.com)
  [key: string]: any;
}

const PrefixInput: React.FC<PrefixInput> = ({
  prefix = "https://",
  error,
  onChange,
  value,
  ...props
}) => {
  // Extract the part after the prefix for display in input
  const inputValue = value?.startsWith(prefix)
    ? value.slice(prefix.length)
    : value;

  const handleChange = (inputVal: string) => {
    // Always return the combined value with prefix
    const fullValue = prefix + inputVal;
    onChange(fullValue);
  };

  const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
    e.currentTarget.blur();
  };

  return (
    <>
      {props.label && (
        <FormLabel
          className="w-full text-black font-medium"
          label={props.label}
        />
      )}
      <div
        className={`rounded-[8px] h-[38px] shadow-sm flex overflow-hidden border ${
          error ? `border-red-500` : ""
        } border-[#D1D5DB]`}
      >
        <div className="bg-[#F9FAFB] py-[8px] px-[12px] fs-14-400 w-fit text-[#4B5563] border-r border-[#D1D5DB]">
          {prefix}
        </div>
        <input
          name={props?.name}
          type="text" // Changed from "number" since URLs are text
          onChange={(e) => handleChange(e.target.value)}
          onWheel={handleWheel}
          value={inputValue} // Show only the part after prefix
          aria-invalid={error ? "true" : "false"}
          className="w-full outline-none border-none text-black px-[8px]"
          {...props}
        />
      </div>
      {error && <ErrorLabel message={error} />}
    </>
  );
};

export default PrefixInput;
